export default "__VITE_ASSET__CYxZs5fp__"